import { Component, OnInit } from '@angular/core';
import { TermsOfUseProperties } from '../Models/CmsFooterContactsProperties';
import { CmsLogoProperties, GetAllCmsLoginProperties } from '../Models/CmsLoginHeaderProperties';
import { CmsLoginMainContentProperties } from '../Models/CmsLoginMainContentProperties';
import { CMSService } from '../Services/cms.service';
import { NavBarMainLoginComponent } from '../nav-bar-main-login/nav-bar-main-login.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-pricingandstructure',
    templateUrl: './pricingandstructure.component.html',
    styleUrls: ['./pricingandstructure.component.css'],
    imports: [NavBarMainLoginComponent, FooterComponent]
})
export class PricingandstructureComponent implements OnInit {
  contentHome: boolean = false;
  allData$: GetAllCmsLoginProperties;
  loginLanding: CmsLoginMainContentProperties[] = [];
  homeLogo = new CmsLogoProperties();
  logo = '';
  termsGetObj = new TermsOfUseProperties();
  constructor(public cmsService: CMSService) { }

  ngOnInit() {
    this.getAllData();
    this.getTermsOfUse();
  }

  getAllData() {
    try {
      this.cmsService.getAllLoginPageData().subscribe((data) => {
        this.allData$ = data;
        //this.activatedRoute.snapshot.data.homeData;
        /*this.navigation = this.allData$.navigation;*/
        this.loginLanding = this.allData$.loginLanding;
        //this.deals = this.allData$.deals;
        //this.footerContacts = this.allData$.footerContacts;
        //this.footerSitemap = this.allData$.footerSitemap;
        //this.footerSocial = this.allData$.footerSocial;
        this.logo = this.allData$.logo[0].logo;
        //this.logo = this.homeLogo.logo;
        this.contentHome = true;
        //this.filtersLoaded = Promise.resolve(true);
      });
    } catch (e) { }
  }

  getTermsOfUse() {
    try {
      this.cmsService.getTermsOfUse().subscribe((data) => {
        this.termsGetObj = data;
      });
    } catch (e) {

    }
  }
}
